export { default } from './mergeClasses';


//////////////////
// WEBPACK FOOTER
// C:/Users/Hong/Desktop/cafe/sc/ministudy/node_modules/@material-ui/styles/esm/mergeClasses/index.js
// module id = 129
// module chunks = 0